var _path;
import * as React from "react";
function SvgChevronLightLeft(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.464 35.746l1.431-1.43a.867.867 0 000-1.227L15.837 20 28.895 6.911a.867.867 0 000-1.226l-1.43-1.431a.867.867 0 00-1.227 0L11.105 19.387a.867.867 0 000 1.226l15.133 15.133a.867.867 0 001.226 0z"
  })));
}
export default SvgChevronLightLeft;